export default __webpack_public_path__ + "static/media/noexpl_04_EN.4ebe0035.png";